import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('video', '.video');
loader('mobile-menu', '.minimenu__list .minimenu__item--has-children');
loader('menu-back', '.minimenu__back');
loader('tabs', '.landingpage-tabs-image');
loader('toggler', '.toggler');
loader('filter-select', '.filter-select');
loader('filter-input', '.filter-input');
loader('cta-download-popup', '.cta-download-popup');
loader('hero-popup', '.hero-popup');
loader('scrollTo', 'a[href^="#"]');
loader('popup', '.footer .popup');
loader('lightbox', '.image-gallery--lightbox');
loader('order-form', '#gform_wrapper_43');
loader('popup-newsletter', '.footer .newsletter-popup');
loader('hero-video', '.hero-video');
loader('header', '.header--desktop');
loader('dropdown', '.header-dropdown');
loader('search', '.search-toggler');
loader('instantsearch');
loader('hero-search', '.hero-search');
loader('width-equalizer', '.grow-child-width');
loader('header-button', '.header-button');
loader('form', '.gform_body');

window.onload = async () => {
  const searchBars: NodeListOf<HTMLElement> = document.querySelectorAll('.search-component');
  if (searchBars.length) {
    searchBars.forEach((searchElem: HTMLElement) => {
      import('./header-search').then((module) => module.default(searchElem));
    });
  }

  const dropdowns: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.megamenu__item--has-children.megamenu__item--d1',
  );
  if (dropdowns.length) {
    dropdowns.forEach((menuItem: HTMLElement) => {
      import('./dropdownd1').then((module) => module.default(menuItem));
    });
  }

  const subsiteDropdowns: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.header-dropdown--subsite',
  );
  if (subsiteDropdowns.length) {
    subsiteDropdowns.forEach((dropdown: HTMLElement) => {
      import('./subsite-dropdowns').then((module) => module.default(dropdown));
    });
  }
};
